declare var API: { discount: string };
declare var LANG: { discountAPIError: string };

const $discount = $('.js-discount');
const $input = $('.js-discount-input');
const $btn = $('.js-discount-btn');
const $hidden = $('.js-discount-hidden');
const $message = $('.js-discount-message');

const MIN_DISCOUNT_LEN: number = 6;

const discount = {
  initialize() {
    if ($discount.length) {
      this.createListeners();
    }
  },

  createListeners() {
    $btn.on('click', () => {
      const val: any = $input.val();

      if (val.length > MIN_DISCOUNT_LEN) {
        this.runCheck(val);
      }
    });
  },

  runCheck(val: string) {
    $.ajax({
      url: `${API.discount}?code=${val}`,
      success: (res) => {
        this.outputMessage(res, 'ok');
        this.handleDiscount(res);
      },
      error: (res) => {
        this.outputMessage(res.responseJSON, 'error');
        this.handleDiscount(res.responseJSON);
      },
    });
  },

  outputMessage(res: { message: string }, status: string) {
    const msg = typeof res.message !== 'undefined' ? res.message : LANG.discountAPIError;

    $message
      .text(msg)
      .removeClass('u-color-positive u-color-negative')
      .addClass(status === 'ok' ? 'u-color-positive' : 'u-color-negative');
  },

  handleDiscount(res: { discount: string }) {
    if (typeof res.discount === 'undefined') {
      return;
    }

    const discountVal = res.discount;

    $hidden.val(discountVal).trigger('change');

    $(document).trigger('cart:recalculate');
  },
};

export default discount;
